
// workaround for including CookieModal without chunk splitting
// see config.resolve.alias.set in vue.config.js for more details.
export default require('./CookieModal').default
